/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-06 10:31:31                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-11-06 10:31:31                               *
 *****************************************************************************/

import { useEffect, useState } from "react";
import { t } from "../../../i18n";
import MultiCheckSelect from "../../option-select/MultiCheckSelect";
import { reactSelectTheme } from "../../option-select/reactSelectTheme";

interface WorkorderStatusSelectProps {
    value?: string[],
    onChange?: (values: string[]) => void,
    disabled?: boolean
}

/*
 * WorkorderStatusSelect: workorder status select component
 * Used to select a workorder status for a workorder
*/
const WorkorderStatusSelect = (props: WorkorderStatusSelectProps) => {
  const [workorderStatusListState, setWorkorderStatusListState] = useState<any[]>([]);
  const [valueState, setValueState] = useState<any>(null);

  useEffect(() => {
    const list = [
      "CREATED",
      "ACCEPTED",
      "IN_TRANSIT",
      "IN_PROGRESS",
      "SUSPENDED",
      "CANCELED",
      "CLOSED",
      "VALIDATED",
      "INVOICED",
      "PAID"
    ];
 
    setWorkorderStatusListState(list.map((e) => {
      return {value: e, label: t("workorder:status."+e.toLowerCase())};
    }));

    if (props.value) {
      setValueState(props.value.map((val) => {
        return {value: val, label: t("workorder:status."+val.toLowerCase())};
      }));
    }
  }, [props.value]); // get workorderStatus list

  const workorderStatusChange = ((value: any) => {
    setValueState(value);
    if (props.onChange)  
      props.onChange(value.map((val: {value: string, label: string}) => {
        return val.value;
      }));
  });

  return (
    <div className="flex w-full min-w-0">
      <MultiCheckSelect options={workorderStatusListState}
        value={valueState}
        theme={reactSelectTheme}
        onChange={workorderStatusChange}
        name="workorderStatus"
        placeholder={t("common:selectInterventionStatus")}
        className="min-w-0 w-full"
        classNamePrefix="react-select"
        isDisabled={props.disabled} />
    </div>
  );
};

export default WorkorderStatusSelect;
